import { ChevronDownIcon, ChevronUpIcon, StarIcon } from "@heroicons/react/24/solid";
import React, { useState } from "react";
import useAppContext from "state/AppContext";

export default function OrderStatusOnboarding() {
  const appContext = useAppContext();
  const [showContent, setShowContent] = useState(true);

  function handleToggle() {
    setShowContent(!showContent);
  }

  const { getStartedVideo } = appContext.selectedOrder.videos;
  const containerStyles = "mb-[30px] bg-white rounded-xl shadow-md blur-2 text-opacity-15 spread-0";
  const buttonStyles = `w-full flex items-stretch justify-between py-4 px-6 ${showContent ? "border-b border-b-gray-300" : ""}`;

  return (
    <div className={containerStyles}>
      <button className={buttonStyles} onClick={handleToggle}>
        <header className="flex items-center flex-1">
          <div className="bg-blue-600 rounded-lg p-1 flex items-center justify-center h-[25px] w-[25px] mr-2">
            <StarIcon className="h-3 w-3 text-white" />
          </div>
          <h3 className="text-lg font-semibold">Learn the Hiring Process</h3>
        </header>
        <footer className="flex items-center ">
          {showContent ? <ChevronUpIcon className="block h-4 w-4" /> : <ChevronDownIcon className="block h-4 w-4" />}
        </footer>
      </button>
      {showContent ? (
        <div className="p-6">
          <div className="mb-6">
            <p className="text-sm leading-6">Get to know your Dashboard in 100 seconds</p>
          </div>
          <iframe
            src={getStartedVideo.url}
            title={getStartedVideo.title}
            className="w-full h-[400px] rounded-2xl"
            allowFullScreen
          ></iframe>
        </div>
      ) : null}
    </div>
  );
}
